import * as toastr from 'toastr';
import { PluginObject } from 'vue';
import { Vue as VueType } from 'vue/types/vue';
import { NotificationInterface } from '@/services/Users-profile/interfaces';

declare module 'vue/types/vue' {
  interface Vue {
    $notifications: NotificationsFacade;
  }
}

export enum NotificationLevel {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

abstract class NotificationsFacade {
  public abstract userNotifications: NotificationInterface[];

  public abstract addNotification(notification: NotificationInterface): void;

  public abstract removeNotification(notificationId: string): void;

  public abstract show(type: NotificationLevel, title: string, body?: string, options?: ToastrOptions): void

  public abstract success(title: string, body?: string, options?: ToastrOptions): void

  public abstract error(title: string, body?: string, options?: ToastrOptions): void

  public abstract info(title: string, body?: string, options?: ToastrOptions): void

  public abstract warning(title: string, body?: string, options?: ToastrOptions): void
}

export class ToastrNotifications extends NotificationsFacade {
  public userNotifications: NotificationInterface[] = [];

  public addNotification(notification: NotificationInterface): void {
    this.userNotifications.push(notification);
    this.userNotifications = this.userNotifications.sort((
      notificationA,
      notificationB,
    ) => new Date(notificationB.date).getTime() - new Date(notificationA.date).getTime());
  }

  public removeNotification(notificationId: string): void {
    this.userNotifications = this.userNotifications
      .filter((notification) => notification._id !== notificationId);
  }

  public show(type: NotificationLevel, body: string, title: string, options?: ToastrOptions): void {
    toastr[type](body, title, options);
  }

  public success(body: string, title: string, options?: ToastrOptions): void {
    toastr.success(body, title, options);
  }

  public error(body: string, title: string, options?: ToastrOptions): void {
    toastr.error(body, title, options);
  }

  public info(body: string, title: string, options?: ToastrOptions): void {
    toastr.info(body, title, options);
  }

  public warning(body: string, title: string, options?: ToastrOptions): void {
    toastr.warning(body, title, options);
  }
}

export function NotificationsPlugin(defaultOptions: ToastrOptions = {}): PluginObject<any> {
  return {
    install(vue: typeof VueType): void {
      vue.prototype.$notifications = new ToastrNotifications();
      Object.assign(toastr.options, defaultOptions);
    },
  };
}
